<template>
  <div>
    <LogoHome />
    <v-container fluid grid-list-md text-center>
      <v-layout row wrap>
        <v-flex xs12 md4 offset-md4>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-card
                class="elevation-15 clickable transparente pa-1"
                v-ripple="{ center: true }"
                @click="abrirMenu($menuPos1)"
                dark
              >
                <v-card-text>
                  <span class="overline">POS</span>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 md6 v-if="$store.state.nombreRol == 'Admin'">
              <v-card
                class="elevation-15 clickable transparente pa-1"
                v-ripple="{ center: true }"
                @click="abrirMenu($menuAdministracion)"
                dark
              >
                <v-card-text>
                  <span class="overline">Administración</span>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </div>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { AUTH_REQUEST } from "@/store/store";
import LogoHome from "@/components/LogoHome";
import Mensaje from "@/components/Mensaje";
export default {
  name: "Home",
  components: {
    LogoHome,
    Mensaje
  },
  data() {
    return {
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      itemActivo: {
        Licencia: "",
        Habilitacion: ""
      }
    };
  },
  computed: {
    sysNombre() {
      return this.$store.state.sysNombre;
    },
    sysDireccionLocalidad() {
      return this.$store.state.sysDireccionLocalidad;
    },
    sysTelefonoEmail() {
      return this.$store.state.sysTelefonoEmail;
    },
    sysForegroundColor() {
      return this.$store.state.sysForegroundColor;
    },
    nombreUsuario() {
      return this.$store.state.nombreUsuario;
    }
  },
  created() {
    this.$store.dispatch("setearAppTitulo", "Bienvenido");
    this.inicializarSistema();
  },
  methods: {
    inicializarSistema() {
      HttpHelper.get("Sistema", {
        id: 1
      })
        .then(response => {
          if (response.data.Resultado == "OK") {
            this.$store.dispatch("setearSysNombre", response.data.Nombre);
            this.$store.dispatch(
              "setearSysDireccionLocalidad",
              response.data.Direccion + " " + response.data.NombreLocalidad
            );
            this.$store.dispatch(
              "setearSysTelefonoEmail",
              "Tel." + response.data.Telefono + " " + response.data.Email
            );
            this.$store.dispatch(
              "setearSysId_TipoIva",
              response.data.Id_TipoIva
            );
            this.$store.dispatch(
              "setearSysAlicuotaIvaBasico",
              response.data.AlicuotaIvaBasico
            );
            this.$store.dispatch(
              "setearSysAlicuotaIvaDiferencial",
              response.data.AlicuotaIvaDiferencial
            );
            this.$store.dispatch(
              "setearSysForegroundColor",
              response.data.ForegroundColor
            );
            this.$store.dispatch(
              "setearSysBackgroundColor",
              response.data.BackgroundColor
            );
            if (response.data.Menu && this.nombreUsuario != "20-23872447-4")
              this.abrirMenu(response.data.Menu);
          }
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    abrirMenu(menu) {
      this.$store.dispatch("setearAppMenu", menu);
      HttpHelper.get("PuntoVenta/BuscarPorMenu/", {
        menu: menu
      })
        .then(response => {
          if (response.data.Resultado == "OK") {
            this.$store.dispatch("setearAppTitulo", response.data.Nombre);
            this.$store.dispatch(
              "setearAppId_PuntoVenta",
              response.data.Id_PuntoVenta
            );
            this.$router.push({
              name: menu
            });
          } else
            this.mostrarMensaje(
              true,
              "Error",
              "El Punto de Venta para el menú " + menu,
              response.data.Resultado
            );
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    ejecutarAccion(accion) {
      if (accion == "CancelarError") this.mostrarMensaje(false);
    },
    abrirOpcion(ruta, params) {
      if (ruta != this.$route.name)
        this.$router.push({ name: ruta, params: params });
    },
    mostrarError(error) {
      var detalle;
      detalle =
        error.response === undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
